/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for EmailSummary controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { EmailSummaryRequest, RequestOptions, EmailSummaryResponse } from "../models";

@Injectable({ providedIn: "root" })
export class EmailSummaryService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    postInvoiceEmailSummaryApiInvoiceEmailSummaryPost(emailSummaryRequest: EmailSummaryRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<EmailSummaryResponse>;
    postInvoiceEmailSummaryApiInvoiceEmailSummaryPost(emailSummaryRequest: EmailSummaryRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EmailSummaryResponse>>;
    postInvoiceEmailSummaryApiInvoiceEmailSummaryPost(emailSummaryRequest: EmailSummaryRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EmailSummaryResponse>>;
    /** Generate AI risk indicators and rationale for S10 approval/verification emails. Called once per recipient language by IS 402. Requires scope=email-enrich. */
    postInvoiceEmailSummaryApiInvoiceEmailSummaryPost(emailSummaryRequest: EmailSummaryRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/invoice_email_summary`;

        const requestOptions: any = {
            observe: observe as any,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, emailSummaryRequest, requestOptions);
    }
}
